//高鐵選擇班次區
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type

//Redux
import { RootState } from '@redux/store';

// import module
import IcRcln from '@magaele/ic_rcln';

// component

// svg component
import Train from '@svg/Train';
import Alert from '@svg/Alert';
import SearchNone from '@svg/SearchNone';

// icon component
import LoadingIcon from '@svg/LoadingIcon';
import Loading from '@Common/loading';

// common function
import { addSeparator } from '@libs/core';
import { getTHSROtherTimeDetail } from '@libs/apiCall';

// plugin
import dayjs from 'dayjs';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

// redux actions
import {
    setTHSRDepartTrain,
    setTHSRReturnTrain,
    setTHSRDetailLoading,
    setTHSROtherTimeLoading,
    setTHSRDetailData,
    setTHSRTempTrainItems,
} from '@redux/THSR/actions';

interface ITrainBlockProps {
    tripDirection: number; //0:去程 1:回程
    data: any;
}

const TrainBlock: React.FC<ITrainBlockProps> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const store_THSR = useSelector((state: RootState) => state.THSR);
    const { ETID } = useSelector((state: RootState) => state.Common);

    const [selectedTrain, setSelectedTrain] = useState<string>('');
    const [earlierTime, setEarlierTime] = useState<string>(''); //儲存更早的時間
    const [laterTime, setLaterTime] = useState<string>(''); //儲存更晚的時間
    const controller = useRef<any>(null); //存放 axios 的中斷相關資料

    //如果班次查詢失敗或call api的時候報錯的畫面
    const renderError = (text) => {
        return (
            <div className="errorContainer">
                <div className="errorContent">
                    {true ? <SearchNone /> : <Alert />}
                    <span>{text}</span>
                </div>
            </div>
        );
    };

    async function fetchOtherTimeDetail(req, direction, timeType) {
        dispatch(setTHSRDetailLoading(true));
        dispatch(setTHSROtherTimeLoading(props.tripDirection));
        if (controller.current) {
            controller.current.abort();
        }
        controller.current = new AbortController();
        let signal = controller.current.signal;
        let response = await getTHSROtherTimeDetail({
            signal: signal,
            req: { ...req, direction: direction },
        });
        if (response) {
            dispatch(setTHSRDetailLoading(false));
            dispatch(setTHSROtherTimeLoading(null));
            if (response.Rounds && !response.error) {
                let newRounds = store_THSR.THSRDetailData.Rounds.map((child, i) => {
                    //i&direction:0為去程1為回程
                    if (i === direction) {
                        return response?.Rounds[0];
                    } else {
                        return child;
                    }
                });
                //在store裡面的班次（用於render的）
                let store_Trains = store_THSR?.THSRDetailData?.Rounds[direction]?.TrainItems;
                //API call回來的班次
                let res_Trains = response?.Rounds[0]?.TrainItems;
                if (
                    res_Trains[0].TrainNumber === store_Trains[0].TrainNumber &&
                    res_Trains[res_Trains.length - 1].TrainNumber ===
                        store_Trains[store_Trains.length - 1].TrainNumber &&
                    timeType === 'earlier'
                ) {
                    //只有點擊更早的需要判斷暫存班次有沒有
                    let nowIndex = -1;
                    store_THSR.THSRTempTrainItems[direction].forEach((child, i) => {
                        if (child.TrainNumber === store_Trains[0].TrainNumber) {
                            nowIndex = i;
                        }
                    });

                    if (nowIndex > 0) {
                        newRounds[direction].TrainItems = store_THSR.THSRTempTrainItems[
                            direction
                        ].slice(nowIndex - 1, nowIndex + 4);
                    }
                }
                //計算出要存進暫存的班次
                calcTempTrainItems(newRounds, direction);
                dispatch(setTHSRDetailData({ Rounds: newRounds }));
            }
        }
    }
    //計算出要存進暫存的班次
    const calcTempTrainItems = (responseRounds, direction) => {
        let newTempTrainItems = [...store_THSR.THSRTempTrainItems].map((child) => {
            return child.map((child) => {
                return JSON.stringify(child);
            });
        });
        responseRounds[direction].TrainItems.forEach((element) => {
            //如果沒有才要存
            if (!newTempTrainItems[direction].includes(JSON.stringify(element))) {
                newTempTrainItems[direction].push(JSON.stringify(element));
            }
        });

        newTempTrainItems = newTempTrainItems.map((child) => {
            return child.map((child) => {
                return JSON.parse(child);
            });
        });

        newTempTrainItems = newTempTrainItems.map((child) => {
            return child.sort((a, b) =>
                dayjs(dayjs().format('YYYY/MM/DD') + ' ' + a.DepartTime).isAfter(
                    dayjs(dayjs().format('YYYY/MM/DD') + ' ' + b.DepartTime)
                )
                    ? 1
                    : -1
            );
        });
        dispatch(setTHSRTempTrainItems(newTempTrainItems));
    };
    //點擊"更晚"
    const clickLater = () => {
        if (store_THSR.THSROtherTimeLoading !== null) return false;
        const lastItem = props.data?.TrainItems[props.data?.TrainItems.length - 1];
        let req = { ...store_THSR.THSRSearchOption, Etcode: ETID };
        if (props.tripDirection === 0) {
            //去程更晚
            //去程的要帶進startTime
            req.startTime = dayjs(dayjs().format('YYYY/MM/DD') + ' ' + lastItem.DepartTime).format(
                'HHmm'
            );
        } else {
            //回程更晚
            //回程的要帶進endTime
            req.endTime = dayjs(dayjs().format('YYYY/MM/DD') + ' ' + lastItem.DepartTime).format(
                'HHmm'
            );
        }
        setSelectedTrain('');
        setLaterTime(lastItem.DepartTime);
        fetchOtherTimeDetail(req, props.tripDirection, 'later');
    };
    //點擊"更早"
    const clickEarlier = () => {
        if (store_THSR.THSROtherTimeLoading !== null) return false;
        const firstItem = props.data?.TrainItems[0];
        if (
            dayjs(dayjs().format('YYYY/MM/DD') + ' ' + firstItem.DepartTime).format('HH') === '00' ||
            dayjs(dayjs().format('YYYY/MM/DD') + ' ' + firstItem.DepartTime).format('HH') === '24'
        )
            return false;
        let req = { ...store_THSR.THSRSearchOption, Etcode: ETID };
        if (props.tripDirection === 0) {
            //去程更早
            //去程的要帶進startTime
            req.startTime = dayjs(dayjs().format('YYYY/MM/DD') + ' ' + firstItem.DepartTime)
                .subtract(1, 'hour')
                .format('HHmm');
        } else {
            //回程更早
            //回程的要帶進endTime
            req.endTime = dayjs(dayjs().format('YYYY/MM/DD') + ' ' + firstItem.DepartTime)
                .subtract(1, 'hour')
                .format('HHmm');
        }
        setSelectedTrain('');
        setEarlierTime(firstItem.DepartTime);
        fetchOtherTimeDetail(req, props.tripDirection, 'earlier');
    };

    useEffect(() => {
        let TrainInfo = props.data?.TrainItems.filter(
            (child) => child.TrainNumber === selectedTrain
        )[0];
        if (props.tripDirection === 0) {
            dispatch(setTHSRDepartTrain(TrainInfo));
        } else {
            dispatch(setTHSRReturnTrain(TrainInfo));
        }
    }, [selectedTrain]);

    //若有班次則預選第一筆
    useEffect(() => {
        props.data?.TrainItems.length > 0 &&
            setSelectedTrain(props.data?.TrainItems[0].TrainNumber);
    }, []);

    return props.data == null ? 
    (
        <div className="roundsContainer">
            {laterTime === '' && earlierTime === ''
                ? renderError(t('THSR.commonPanel.searchOtherTrainNumber'))
                : renderError(t('THSR.commonPanel.laterTrains'))}
        </div>
    ) : (
        <div className="roundsContainer">
            <div className="roundsTitle">
                <span className="tranIcon">
                    <Train />
                </span>
                <span>
                    {props.tripDirection === 0 ? t('THSR.commonPanel.outboundTrip') : t('THSR.commonPanel.returnTrip')}{t('THSR.commonPanel.destination',{symbol: ': '})}
                    {props.data?.ArriveStation.text}{t('THSR.commonPanel.state')}
                </span>
                <span className="empty"></span>
                <button
                    onClick={() => props.data?.TrainItems.length > 0 && clickEarlier()}
                    className={cx('prev', {
                        disable:
                            props.data?.TrainItems.length <= 0 ||
                            dayjs('2011/11/11' + props.data?.TrainItems[0].DepartTime).format(
                                'HH'
                            ) === '00' ||
                            dayjs('2011/11/11' + props.data?.TrainItems[0].DepartTime).format(
                                'HH'
                            ) === '24',
                    })}
                >
                    <IcRcln name="toolbefore" color="#222222" />
                    {t('THSR.commonPanel.earlier')}
                </button>
                <button
                    onClick={() =>
                        props.data?.TrainItems.length > 0 &&
                        props.data?.TrainItems.length >= 5 &&
                        clickLater()
                    }
                    className={cx('next', {
                        disable:
                            props.data?.TrainItems.length <= 0 || props.data?.TrainItems.length < 5,
                    })}
                >
                    {t('THSR.commonPanel.later')}
                    <IcRcln name="toolnext" />
                </button>
            </div>
            <ul className="tranList">
                {props.data?.TrainItems.map((child, index) => {
                    return (
                        <li
                            onClick={() => {
                                if (child.TrainNumber === selectedTrain) {
                                    setSelectedTrain('');
                                } else {
                                    setSelectedTrain(child.TrainNumber);
                                }
                            }}
                            className={cx('', {
                                selected: selectedTrain === child.TrainNumber,
                                hide: selectedTrain !== '' && selectedTrain !== child.TrainNumber,
                            })}
                        >
                            {selectedTrain === child.TrainNumber && (
                                <IcRcln name="toolchoose" style={{ fontSize: '18px' }} />
                            )}
                            <span className="trainNumber">
                                {t('THSR.commonPanel.trainNumber')}{'\u00A0'}
                                <br />
                                {child.TrainNumber}
                            </span>
                            <span className="trainTime">
                                <span className="departTime">{child.DepartTime}</span>
                                <span className="arrow">→</span>
                                <span className="arriveTime">{child.ArriveTime}</span>
                            </span>
                            <span className="trainPrice">
                                <span className="duration">
                                    <span className="d-n-m">{t('THSR.commonPanel.trainTime')}</span>{' '}
                                    {child.Duration}
                                </span>
                                <span className="price">
                                    {store_THSR.THSRDetailData?.Rounds.length > 1 ? t('THSR.commonPanel.outboundTripAndReturnTrip') : t('THSR.commonPanel.all')}{' '}
                                    ${addSeparator(store_THSR.THSRInfo?.TicketsInfo?.totalPrice)}
                                </span>
                            </span>
                        </li>
                    );
                })}
                {props.data?.TrainItems.length === 0 && renderError(t('THSR.commonPanel.searchOtherTrainNumber'))}
            </ul>
            {store_THSR.THSROtherTimeLoading === props.tripDirection && (
                <div className="loadBlock">
                    <Loading icon={<LoadingIcon />} text={t('THSR.commonPanel.loading_trainNumber')} />
                </div>
            )}
            {selectedTrain ? (
                <button
                    className={cx('showMoreM')}
                    onClick={() => {
                        setSelectedTrain('');
                    }}
                >
                    {t('THSR.commonPanel.chooseOtherTrainNumber')}
                    <IcRcln name="toolnext" />
                </button>
            ) : (
                <>
                    <button
                        onClick={() => props.data?.TrainItems.length > 0 && clickEarlier()}
                        className={cx('prevM', {
                            disable:
                                props.data?.TrainItems.length <= 0 ||
                                dayjs(
                                    dayjs().format('YYYY/MM/DD') +
                                        ' ' +
                                        props.data?.TrainItems[0].DepartTime
                                ).format('HH') === '00' ||
                                dayjs(
                                    dayjs().format('YYYY/MM/DD') +
                                        ' ' +
                                        props.data?.TrainItems[0].DepartTime
                                ).format('HH') === '24',
                        })}
                    >
                        {t('THSR.commonPanel.earlierTrains')}
                    </button>
                    <button
                        onClick={() =>
                            props.data?.TrainItems.length > 0 &&
                            props.data?.TrainItems.length >= 5 &&
                            clickLater()
                        }
                        className={cx('nextM', {
                            disable:
                                props.data?.TrainItems.length <= 0 ||
                                props.data?.TrainItems.length < 5,
                        })}
                    >
                         {t('THSR.commonPanel.laterTrains')}
                    </button>
                </>
            )}
        </div>
    );
};

export default TrainBlock;